import script from "./CategorizedUsersQuery.vue?vue&type=script&lang=js"
export * from "./CategorizedUsersQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__